/** @file watchDevicePixelRatio: calls back on window resize and on a devicePixelRatio change (zoom, monitor). */

/**
 * Calls `onChange(devicePixelRatio)` on window `resize` and when `matchMedia('(resolution: <dpr>dppx)')` stops
 * matching (the query is renewed for the new ratio); returns the function that removes both listeners.
 */
export function watchDevicePixelRatio(onChange: (dpr: number) => void): () => void {
  let query: MediaQueryList | null = null;
  const fire = (): void => { onChange(window.devicePixelRatio); };
  const onRatio = (): void => {
    listen();
    fire();
  };
  function listen(): void {
    query?.removeEventListener('change', onRatio);
    query = window.matchMedia(`(resolution: ${String(window.devicePixelRatio)}dppx)`);
    query.addEventListener('change', onRatio);
  }
  listen();
  window.addEventListener('resize', fire);
  return () => {
    query?.removeEventListener('change', onRatio);
    window.removeEventListener('resize', fire);
  };
}
